import { render, staticRenderFns } from "./UserNotFound.vue?vue&type=template&id=334554c0&scoped=true&"
import script from "./UserNotFound.vue?vue&type=script&lang=js&"
export * from "./UserNotFound.vue?vue&type=script&lang=js&"
import style0 from "./UserNotFound.vue?vue&type=style&index=0&id=334554c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334554c0",
  null
  
)

export default component.exports